/**
 * Route for `campaign-geo-targeting`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignGeoTargetingPage } from "../features/campaign-geo-targeting/CampaignGeoTargetingPage";

export const campaignGeoTargetingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-geo-targeting",
	component: CampaignGeoTargetingPage,
});

export default campaignGeoTargetingRoute;
